export enum TrackingEvent {
  SelectProperty = `Select Property`,
  SelectPropertiesDropdownOption = `Select properties dropdown option`,
  CreateInlineCohort = `Created Inline Cohort`,
  EditInlineCohorts = `Edit Inline Cohort`,
  SaveInlineCohorts = `Save Inline Cohort`,
  OpenInlineCohortsModal = `Opened Inline Cohorts Modal`,
  CreateCustomProperty = `Custom Property - create`,
}
